import type ItemReadingPaneViewState from '../store/schema/ItemReadingPaneViewState';
import { getStore } from '../store/Store';
import { isFeatureEnabled } from 'owa-feature-flags';
import getActiveTabId from './getActiveTabId';

export default function getItemReadingPaneViewState(itemId?: string): ItemReadingPaneViewState {
    if (isFeatureEnabled('rp-persistedReadingPaneTabs')) {
        return getStore().loadedItemReadingPaneViewStates.get(itemId || getActiveTabId());
    }
    return getStore().itemReadingPaneViewState;
}
